module.exports = __webpack_public_path__ + "static/img/top.59efe7a4.png";